import { Box } from "@mui/material";

export default function NotFound404() {
  return (
    <Box sx={{ textAlign: "center", padding: "20px" }}>
      <h1>404 Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <p>Please check the URL or return to the home page.</p>
    </Box>
  );
}
